import { render, staticRenderFns } from "./setup_env.vue?vue&type=template&id=38075295"
import script from "./setup_env.vue?vue&type=script&lang=js"
export * from "./setup_env.vue?vue&type=script&lang=js"
import style0 from "./setup_env.vue?vue&type=style&index=0&id=38075295&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports